/**
 * IDE Command Group
 * Manages IDE integration commands: context, setup, sync, status
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createContextSubcommand } from './context.js';
import { createSetupSubcommand } from './setup.js';
import { createSyncSubcommand } from './sync.js';
import { createStatusSubcommand } from './status.js';

function showIdeHelp(): void {
    console.log(chalk.bold.cyan('🖥️  jai1 ide') + chalk.dim(' - IDE integration và cấu hình'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('context')}   Duyệt và khám phá IDE context`);
    console.log(`  ${chalk.cyan('setup')}     Cấu hình IDE settings (VSCode optimizations)`);
    console.log(`  ${chalk.cyan('sync')}      Đồng bộ .jai1 content đến IDE directories`);
    console.log(`  ${chalk.cyan('status')}    Hiển thị các IDE được phát hiện và trạng thái`);
    console.log();
    console.log(chalk.bold('IDEs được hỗ trợ:'));
    console.log(chalk.dim('  Cursor, Windsurf, VSCode, Trae, Claude'));
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 ide status'));
    console.log(chalk.dim('  $ jai1 ide setup --optimize'));
    console.log(chalk.dim('  $ jai1 ide sync'));
    console.log(chalk.dim('  $ jai1 ide context'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 ide <lệnh> --help" để xem chi tiết'));
}

/**
 * Create IDE command group
 */
export function createIdeCommand(): Command {
    const ideCommand = new Command('ide')
        .description('IDE integration and configuration commands')
        .action(() => {
            showIdeHelp();
        });

    // Add subcommands
    ideCommand.addCommand(createContextSubcommand());
    ideCommand.addCommand(createSetupSubcommand());
    ideCommand.addCommand(createSyncSubcommand());
    ideCommand.addCommand(createStatusSubcommand());

    return ideCommand;
}
